import {
  DashboardOutlined,
  DollarOutlined,
  FileOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const StyledLayoutSider = styled(Layout.Sider)`
  overflow: auto;
  min-height: calc(100vh - 64px);
  left: 0;
  top: 64px;
  bottom: 0;
  padding-top: 6px;
  height: 100%;

  .ant-layout-sider-trigger {
    position: absolute;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const headerMenuItems = [
  {
    key: "accounts",
    icon: <DashboardOutlined />,
    title: "Accounts",
    label: <Link to="/accounts">My Accounts</Link>,
  },
  // {
  //   key: "accounts",
  //   icon: <UserOutlined />,
  //   title: "Accounts",
  //   label: <Link to="/accounts">Accounts</Link>,
  // },
  {
    key: "documents",
    icon: <FileOutlined />,
    title: "Documents",
    label: <Link to="/documents">Documents</Link>,
  },
  {
    key: "payments",
    icon: <DollarOutlined />,
    title: "Payments",
    label: "Payments",
    children: [
      {
        key: "payments/make-payment",
        title: "Make Payment",
        label: <Link to="/payments/make-payment">Make Payment</Link>,
      },
      {
        key: "payments/payment-methods",
        title: "Payment Methods",
        label: <Link to="/payments/payment-methods">Payment Methods</Link>,
      },
      {
        key: "payments/upcoming-payments",
        title: "Upcoming Payments",
        label: <Link to="/payments/upcoming-payments">Upcoming Payments</Link>,
      },
    ],
  },
  {
    key: "contact",
    icon: <QuestionCircleOutlined />,
    title: "Contact Us",
    label: <Link to="/contact">Contact Us</Link>,
  },
];

function AppMenu(props) {
  const { inDrawer = false, onMenuItemClick } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState(["payments"]);

  const pathway = location.pathname.substring(1); // removes leading slash
  const selectedKeys = [pathway ?? headerMenuItems[0].key]; // select based on pathway or default to first item
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const handleMenuClick = (info) => {
    if (inDrawer && onMenuItemClick) {
      onMenuItemClick();
    }
  };

  const menuComponent = (
    <Menu
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      onClick={handleMenuClick}
      theme="dark"
      mode="inline"
      items={headerMenuItems}
      selectedKeys={selectedKeys}
    />
  );

  if (inDrawer) {
    return menuComponent;
  }

  return (
    <StyledLayoutSider
      collapsible
      width={225}
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      {menuComponent}
    </StyledLayoutSider>
  );
}

export default AppMenu;
